import React, {useEffect, useState} from 'react';
import {
  Table,
  Row,
  Col,
  Divider,
  Image,
  Pagination,
  Segmented,
  Tabs,
} from 'antd';
import {AppstoreOutlined, TableOutlined} from '@ant-design/icons';
import DynamicSearchForm from '../../CommonComponents/DynamicSearch';
import {useNavigate} from 'react-router-dom';
import {
  CouponCodeRaioOptions,
  DescriptionItem,
  EventOptions,
  EventStatus,
  PageSizeArray,
  PaginationPosition,
  ReturnNAOnEmpty,
  defaultDropdownValue,
  eventStatusOptions,
  truncateStringToWords,
  displayFileName,
} from '../../../Util/commonUtility';
import StatusUpdateModal from '../../CommonComponents/CommonModal';
import AdminActionsDropdown from '../../CommonComponents/AdminActionsDropdown/AdminActionsDropdown';
import {useSelector} from 'react-redux';
import useDebouncedCallback from '../../../hooks/useDebounce';
import AdminViewDetailsDrawer from '../../CommonComponents/AdminViewDetailsDrawer';
import CustomizedTable from './../../CommonComponents/CommonTable/index';
import {applicationConfig} from '../../../Util/config';
import HeaderSearchCard from '../../CommonComponents/HeaderSearchCard';
import {CREATE} from '../../../Constant/enums';
import useLocalization from '../../../Localization';
import './style.css';

const VIEW_STORAGE_KEY = 'eventsAdminViewMode';

const getEventStatusDisplay = (status) => {
  switch (+status) {
    case EventStatus.ACTIVE:
      return {color: 'green', label: 'Active'};
    case EventStatus.DRAFT:
      return {color: 'purple', label: 'Draft'};
    case EventStatus.REG_CLOSED:
      return {color: 'red', label: 'Registration Closed'};
    case EventStatus.PRIVATE:
      return {color: 'magenta', label: 'Private'};
    case EventStatus.TENTATIVE:
      return {color: 'blue', label: 'Tentative'};
    default:
      return {color: 'purple', label: 'Draft'};
  }
};

const EventsComponent = (props) => {
  const eventPageSizeOptions = Array.from(new Set([...PageSizeArray, 25])).sort(
    (a, b) => a - b,
  );
  const [expanded, setExpanded] = useState(false);
  let navigate = useNavigate();
  const {
    eventTypesOptions,
    allEventsData,
    handlePaginationChange,
    paging,
    chaptersOptions,
    sortParams,
    speakerOptions,
    handleTableChange,
    fetchEvents,
    deleteEvents,
    duplicateEvents,
    updateStatusById,
    searchValues,
    fetching,
    setFetching,
    setSpeakerOptions,
    SetEventTypesOption,
    activeFilter,
    onFilterChange,
  } = props;
  const [showUpdateStatus, setShowUpdateStatus] = useState(false);
  const ps = useSelector(({pageSizes}) => pageSizes.pageSizes.events);
  const pn = useSelector(({pageSizes}) => pageSizes.pageNumbers.events);
  const [recordData, setRecordData] = useState();
  const [open, setOpen] = useState(false);
  const [openDrawerDetails, setOpenDrawerDetails] = useState(false);
  // Match tablet and below only — desktop (≥769px) keeps large-screen % layout.
  const [isNarrow, setIsNarrow] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia('(max-width: 768px)').matches
      : false,
  );
  const [viewMode, setViewMode] = useState(() => {
    if (typeof window === 'undefined') return 'table';
    const narrow = window.matchMedia('(max-width: 768px)').matches;
    if (!narrow) return 'table';
    const saved = localStorage.getItem(VIEW_STORAGE_KEY);
    if (saved === 'table' || saved === 'card') return saved;
    return 'card';
  });
  const {ApplicationString} = useLocalization();
  const effectiveViewMode = isNarrow ? viewMode : 'table';

  useEffect(() => {
    searchValues && setExpanded(true);
  }, [searchValues]);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const onChange = (e) => setIsNarrow(e.matches);
    mq.addEventListener('change', onChange);
    setIsNarrow(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const handleViewModeChange = (value) => {
    setViewMode(value);
    localStorage.setItem(VIEW_STORAGE_KEY, value);
  };

  const eventsFilters = [
    {
      key: 'search',
      label: 'Event ID or Name',
      name: 'search',
      placeholder: 'Enter event ID or name',
      initialValue: '',
    },
    // { label: 'Company Name', name: 'company_name', initialValue: '' },
    {
      label: 'Chapter Name',
      name: 'local_chapter_id',
      type: 'dropdown',
      // options: eventStatusOptions,
      initialValue: defaultDropdownValue,
    },
    {
      label: 'Event Type',
      name: 'event_type_id',
      type: 'event_type_id',
      options: eventTypesOptions,
      initialValue: defaultDropdownValue,
    },
    {
      label: 'Status',
      name: 'status',
      type: 'dropdown',
      options: eventStatusOptions,
      initialValue: defaultDropdownValue,
    },
    {
      label: 'Date Range',
      name: 'date',
      type: 'dateRange',
      initialValue: '',
    },
    {
      label: 'Organizers',
      name: 'organizers',
      initialValue: '',
    },
    // {
    //   label: 'Is Online',
    //   name: 'is_online',
    //   type: 'checkbox',
    //   valueProps: 'checked',
    //   initialValue: '',
    // },
    {
      label: 'Online Event',
      name: 'is_online',
      type: 'radio',
      options: CouponCodeRaioOptions,
      initialValue: '',
    },
  ];

  const toggleExpand = () => {
    setExpanded(!expanded);
  };
  const handleSearch = (values) => {
    fetchEvents(values);
  };

  const handleEditClick = async (id) => {
    navigate(`/admin/events/update/${id}`);
  };
  const handleUpdateStatusClick = async (record) => {
    setShowUpdateStatus(+record.status);
    setRecordData(record);
  };
  const handleUpdateStatus = () => {
    updateStatusById(recordData, showUpdateStatus);
    setShowUpdateStatus(false);
  };

  const hideModal = () => {
    setShowUpdateStatus(false);
  };
  const handleChange = (value) => {
    setShowUpdateStatus(+value);
  };

  // debouncing the table & pagination changes to stop too many requests
  const debouncedHandlePaginationChange = useDebouncedCallback(
    handlePaginationChange,
    1000,
  );
  const debouncedTableChange = useDebouncedCallback(handleTableChange, 1000);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  // Drawer functions ----------------------------------------------------
  const showDrawer = (record) => {
    setOpenDrawerDetails(record);
    setOpen(true);
  };

  const onCloseDrawer = () => {
    setOpen(false);
  };

  const EventDrawerContent = () => {
    const {
      name: eventName,
      event_type_name: eventType,
      chapter_name: chapter,
      place,
      is_online: isOnline,
      is_available_for_webcast: isWebcastAvailable,
      online_for_chapters: onlineForChapters,
      webcast_available_for_chapters: webcastAvailableForChapters,
      offline_for_chapters: offlineForChapters,
      details,
      cost_note: costNote,
      speaker_name,
      organizers,
      seats,
      flyer_image_ids,
      vendors,
      occupied_seats: occupiedSeats,
      sponsorship,
      formattedDateTime,
      event_bio: eventBio,
      event_info: eventInfo,
      flyer_url: flyerUrl,
      flyer_text: flyerText,
      speaker_bio: speakerBio,
      registration_price: registrationPrice,
      registration_closes_text: registrationClosesText,
      status,
    } = openDrawerDetails || {};

    const renderList = (items) =>
      items?.length > 0
        ? items?.map((item) => <span key={item}>{`${item}, `}</span>)
        : 'N/A';

    return (
      <>
        <Row>
          <Col span={24}>
            <DescriptionItem title='Event Name' content={eventName} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem title='Event Type' content={eventType} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem title='Local Chapter' content={chapter} />
          </Col>
          <Col span={12}>
            <DescriptionItem
              title='Event Status'
              content={
                {
                  0: 'Active',
                  '-2': 'Private',
                  '-1': 'Tentative',
                  1: 'Draft',
                  2: 'Registration Closed',
                }[status] || status
              }
            />{' '}
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem title='Event Location' content={place} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem
              title='Is this an online only event?'
              content={isOnline ? 'Yes' : 'No'}
            />
          </Col>
          <Col span={12}>
            <DescriptionItem
              title='Webcast for Non-local Attendees'
              content={isWebcastAvailable ? 'Yes' : 'No'}
            />{' '}
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Online Only'
              content={renderList(onlineForChapters)}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Webcast Available For Chapters'
              content={renderList(webcastAvailableForChapters)}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Offline Event Available For Chapters'
              content={renderList(offlineForChapters)}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem title='Event Details' content={details} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem title='Event Speakers' content={speaker_name} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Event Organizers'
              content={organizers || 'N/A'}
            />
          </Col>
        </Row>
        <Divider />

        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Event Registration Fees'
              content={registrationPrice || 'N/A'}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem title='Total Seats' content={seats} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem title='Sponsorships' content={sponsorship || 0} />{' '}
          </Col>
          <Col span={12}>
            <DescriptionItem title='Vendors' content={vendors} />{' '}
          </Col>
        </Row>
        <Divider />
        <Row gutter={20}>
          <Col span={12}>
            <DescriptionItem
              title='Event Flyer'
              content={
                <>
                  {flyerUrl ? (
                    <a
                      href={`${applicationConfig.UPLOAD_URL}/${
                        flyerUrl?.name || flyerUrl
                      }`}
                      target='_blank'
                      rel='noreferrer'>
                      {displayFileName(
                        typeof flyerUrl === 'object'
                          ? flyerUrl
                          : {name: flyerUrl},
                      )}
                    </a>
                  ) : (
                    'N/A'
                  )}
                </>
              }
            />
          </Col>
          <Col span={12}>
            <DescriptionItem title='Flyer text' content={flyerText || 'N/A'} />
          </Col>
        </Row>
        <Divider />
        <Row gutter={20}>
          <Col span={24}>
            <DescriptionItem
              title='Event Flyer Image'
              content={
                <>
                  <Image.PreviewGroup>
                    {flyer_image_ids?.map((image) => (
                      <Image
                        prefixCls='event-flyer-image'
                        crossOrigin='anonymous'
                        key={image?.id}
                        width={'50%'}
                        height={'400px'}
                        src={`${applicationConfig.UPLOAD_URL}/${image?.name}`}
                      />
                    ))}
                  </Image.PreviewGroup>
                </>
              }
            />
          </Col>
        </Row>
        <Divider />

        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Registration Start Date'
              content={`${formattedDateTime?.reg_start_date} ${formattedDateTime?.reg_start_time}`}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Registration End Date'
              content={`${formattedDateTime?.reg_end_date} ${formattedDateTime?.reg_end_time}`}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Event Registration Closes On'
              content={registrationClosesText || 'N/A'}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Event Start Date'
              content={`${formattedDateTime?.event_start_date} ${formattedDateTime?.event_start_time}`}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Event End Date'
              content={`${formattedDateTime?.event_end_date} ${formattedDateTime?.event_end_time}`}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Event Description'
              content={<CustomizedTable TableData={eventBio} />}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Event Agenda'
              content={<CustomizedTable TableData={eventInfo} />}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title="Speakers' Bio"
              content={<CustomizedTable TableData={speakerBio} />}
            />
          </Col>
        </Row>
        <Divider />
      </>
    );
  };

  const renderEventActions = (record) => (
    <AdminActionsDropdown
      record={record}
      handleEditClick={handleEditClick}
      handleUpdateStatusClick={handleUpdateStatusClick}
      handleDeleteClick={deleteEvents}
      handleCopyClick={duplicateEvents}
      deleteBool={true}
      editBool={true}
      statusBool={true}
      copyBool={true}
      viewBool={true}
      handleView={showDrawer}
      text='Event'
      eventNavigate={true}
      resource='events'
    />
  );

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: '6%',
      sorter: true,
    },
    {
      title: 'Event Start Date',
      dataIndex: 'event_start_date_time',
      width: '12%',
      sorter: true,
      render: (event_start_date_time, record) => {
        return (
          <div>
            {`${record?.formattedDateTime?.event_start_date} ${record?.formattedDateTime?.event_start_time}`}
          </div>
        );
      },
    },
    {
      title: 'Event End Date',
      dataIndex: 'formattedDateTime',
      width: '11%',
      render: (formattedDateTime) => {
        return (
          <div>
            {`${formattedDateTime?.event_end_date} ${formattedDateTime?.event_end_time}`}
          </div>
        );
      },
    },
    {
      title: 'Reg Start Date',
      dataIndex: 'formattedDateTime',
      width: '11%',
      render: (formattedDateTime) => {
        return (
          <div>
            {`${formattedDateTime?.reg_start_date} ${formattedDateTime?.reg_start_time}`}
          </div>
        );
      },
    },
    {
      title: 'Reg End Date',
      dataIndex: 'formattedDateTime',
      width: '11%',
      render: (formattedDateTime) => {
        return (
          <div>
            {`${formattedDateTime?.reg_end_date} ${formattedDateTime?.reg_end_time}`}
          </div>
        );
      },
    },

    {
      title: 'Event Name',
      dataIndex: 'name',
      width: '45%',
      sorter: true,
      render: (text, record) => {
        const displayText = record?.event_type_name
          ? `[${record.event_type_name}] ${text} `
          : text;
        return truncateStringToWords(displayText);
      },
    },
    {
      title: 'Local Chapter',
      dataIndex: 'chapter_name',
      width: '9%',
      sorter: false,
    },
    {
      title: 'Location',
      dataIndex: 'place',
      width: '11%',
      sorter: true,
    },
    {
      title: 'Speakers',
      dataIndex: 'speaker_name',
      width: '14%',
      render: (text) => {
        const NAText = ReturnNAOnEmpty(text);
        return truncateStringToWords(NAText);
      },
    },
    // {
    //   title: 'Event Type',
    //   dataIndex: 'event_type_name',
    //   width: '4%',
    //   sorter: false,
    // },
    // {
    //   title: 'Local Chapter',
    //   width: '5%',
    //   dataIndex: 'chapter_name',
    // },
    // {
    //   title: 'Place',
    //   dataIndex: 'place',
    // },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '11%',
      render: (status) => {
        const {color, label} = getEventStatusDisplay(status);
        return <span style={{color: `${color}`}}>{label}</span>;
      },
    },
    {
      title: 'Regular Registrations',
      dataIndex: 'seats',
      width: 200,
      className: 'events-regular-registrations-cell',
      render: (_, record) => {
        return (
          <div className='fixed-size-text events-regular-registrations-text'>
            {record?.seats_registered}/{record?.seats || 0}
            {record?.in_person_capacity != null && (
              <>
                <br />
                (Total In-Person Capacity: {record?.in_person_used ?? 0} /{' '}
                {record?.in_person_capacity})
              </>
            )}
            <br />
            (In-person Registrations: {record?.in_person_registered})
            <br />
            (Webcast Registrations: {record?.webcast_registered})
          </div>
        );
      },
    },
    {
      title: 'Sponsors(Major + HH + LS)',
      dataIndex: 'sponsorship',
      width: '14%',
      render: (_, record) => {
        return (
          <div className='fixed-size-text'>
            {record?.sponsorship_registered}/{record?.sponsorship || 0}
          </div>
        );
      },
    },
    {
      title: 'Exhibitors(Vendors)',
      dataIndex: 'vendors',
      width: '15%',
      render: (_, record) => {
        return (
          <div className='fixed-size-text'>
            {record?.vendors_registered}/{record?.vendors || 0}
          </div>
        );
      },
    },
    {
      title: 'Workshop Attendance (Vendor Reps)',
      dataIndex: 'workshop_attendees_registered',
      width: '11%',
      render: (_, record) => {
        return (
          <div className='fixed-size-text'>
            {record?.workshop_attendees_registered || 0}/
            {record?.workshop_attendees || 0}
          </div>
        );
      },
    },
    {
      title: 'Organizers',
      dataIndex: 'organizers',
      width: '13%',
      render: (text) => {
        const NAText = ReturnNAOnEmpty(text);
        return truncateStringToWords(NAText);
      },
    },

    {
      title: '',
      key: 'action',
      width: '6%',
      render: (_, record) => renderEventActions(record),
    },
  ];
  columns.forEach((column) => {
    if (column.key !== 'action') {
      column.sortOrder =
        sortParams.field === column.dataIndex && sortParams.order;
    }
  });

  // Pixel widths when narrow so cells don't crush; desktop keeps % widths.
  const narrowColumnWidths = [
    70, 200, 200, 200, 200, 240, 120, 140, 160, 150, 280, 180, 160, 200, 160,
    80,
  ];
  const narrowScrollX = narrowColumnWidths.reduce((sum, w) => sum + w, 0);
  const tableColumns = isNarrow
    ? columns.map((column, index) => ({
        ...column,
        width: narrowColumnWidths[index] ?? 140,
        ellipsis: false,
      }))
    : columns;

  const tablePagination = {
    onChange: debouncedHandlePaginationChange,
    current: pn || paging.page,
    total: paging.totalCount,
    pageSize: ps || paging.pageCount,
    pageSizeOptions: eventPageSizeOptions,
    showQuickJumper: true,
    showSizeChanger: true,
    onShowSizeChange: debouncedHandlePaginationChange,
    showTotal: (total, range) => `Total ${total} items`,
    position: [PaginationPosition],
  };

  const cardPagination = {
    onChange: debouncedHandlePaginationChange,
    current: pn || paging.page,
    total: paging.totalCount,
    pageSize: ps || paging.pageCount,
    pageSizeOptions: eventPageSizeOptions,
    showQuickJumper: false,
    showSizeChanger: false,
    onShowSizeChange: debouncedHandlePaginationChange,
    showTotal: (total) => `Total ${total} items`,
    simple: true,
  };

  return (
    <div className='main-container'>
      <AdminViewDetailsDrawer
        content={EventDrawerContent}
        visible={open}
        text={'Event'}
        onCloseDrawer={onCloseDrawer}
        isEditable={openDrawerDetails?.status != EventStatus.ACTIVE}
        editNavigate={`/admin/events/update/${openDrawerDetails?.id}`}
      />
      <StatusUpdateModal
        data={recordData}
        visible={showUpdateStatus === false ? false : true}
        onCancel={hideModal}
        showUpdateStatus={showUpdateStatus}
        handleChange={handleChange}
        handleUpdateJobStatus={handleUpdateStatus}
        selectionOptions={EventOptions}
      />

      <HeaderSearchCard
        resource='events'
        toggleClick={toggleExpand}
        buttonTitle={ApplicationString['eventsComponent.button.addForm']}
        addClick={() => navigate('/admin/events/add')}
        dataTestId='adminEvents-button-addEvents'
        permission={CREATE}
        expanded={expanded}
        extraBefore={
          isNarrow ? (
            <Segmented
              value={viewMode}
              onChange={handleViewModeChange}
              options={[
                {
                  label: 'Table',
                  value: 'table',
                  icon: <TableOutlined />,
                },
                {
                  label: 'Card',
                  value: 'card',
                  icon: <AppstoreOutlined />,
                },
              ]}
            />
          ) : null
        }
      />

      {expanded && (
        <DynamicSearchForm
          columns={eventsFilters}
          eventTypesOptions={eventTypesOptions}
          chaptersOptions={chaptersOptions}
          onSearch={handleSearch}
          savedFilteredValues={searchValues}
          title={'events'}
          fetching={fetching}
          setFetching={setFetching}
          speakerOptions={speakerOptions}
          setSpeakerOptions={setSpeakerOptions}
          SetEventTypesOption={SetEventTypesOption}
        />
      )}
      <Tabs
        className='events-filter-tabs'
        activeKey={activeFilter}
        onChange={onFilterChange}
        onTabClick={(key) => {
          // The active tab does not fire onChange. Clicking it again still
          // needs a reload when the rows on screen belong to the other tab.
          if (key === activeFilter) {
            onFilterChange(key);
          }
        }}
        items={[
          {key: 'upcoming', label: 'Upcoming Events'},
          {key: 'past', label: 'Past Events'},
        ]}
      />
      <div
        className={`listing-container events-listing-container${
          effectiveViewMode === 'table' && isNarrow
            ? ' events-listing-container-narrow'
            : ''
        }`}>
        {effectiveViewMode === 'card' ? (
          <div className='events-mobile-list'>
            {(allEventsData || []).length === 0 ? (
              <div className='events-mobile-empty'>No data</div>
            ) : (
              (allEventsData || []).map((record) => {
                const {color, label} = getEventStatusDisplay(record?.status);
                const eventName = record?.event_type_name
                  ? `[${record.event_type_name}] ${record?.name}`
                  : record?.name;
                const dt = record?.formattedDateTime;
                return (
                  <div className='events-mobile-card' key={record.id}>
                    <div className='events-mobile-card-header'>
                      <div className='events-mobile-card-title-wrap'>
                        <span className='events-mobile-card-id'>
                          ID: {record.id}
                        </span>
                        <p className='events-mobile-card-title'>{eventName}</p>
                      </div>
                      {renderEventActions(record)}
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Event Start Date</span>
                      <span>
                        {dt?.event_start_date} {dt?.event_start_time}
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Event End Date</span>
                      <span>
                        {dt?.event_end_date} {dt?.event_end_time}
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Reg Start Date</span>
                      <span>
                        {dt?.reg_start_date} {dt?.reg_start_time}
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Reg End Date</span>
                      <span>
                        {dt?.reg_end_date} {dt?.reg_end_time}
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Local Chapter</span>
                      <span>{ReturnNAOnEmpty(record?.chapter_name)}</span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Location</span>
                      <span>{ReturnNAOnEmpty(record?.place)}</span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Speakers</span>
                      <span>
                        {truncateStringToWords(
                          ReturnNAOnEmpty(record?.speaker_name),
                        )}
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Status</span>
                      <span style={{color}}>{label}</span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Regular Registrations</span>
                      <span className='events-mobile-card-multiline'>
                        {record?.seats_registered}/{record?.seats || 0}
                        {record?.in_person_capacity != null && (
                          <>
                            <br />
                            (Total In-Person Capacity:{' '}
                            {record?.in_person_used ?? 0} /{' '}
                            {record?.in_person_capacity})
                          </>
                        )}
                        <br />
                        (In-person Registrations: {record?.in_person_registered}
                        )
                        <br />
                        (Webcast Registrations: {record?.webcast_registered})
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Sponsors(Major + HH + LS)</span>
                      <span>
                        {record?.sponsorship_registered}/
                        {record?.sponsorship || 0}
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Exhibitors(Vendors)</span>
                      <span>
                        {record?.vendors_registered}/{record?.vendors || 0}
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Workshop Attendance (Vendor Reps)</span>
                      <span>
                        {record?.workshop_attendees_registered || 0}/
                        {record?.workshop_attendees || 0}
                      </span>
                    </div>
                    <div className='events-mobile-card-row'>
                      <span>Organizers</span>
                      <span>
                        {truncateStringToWords(
                          ReturnNAOnEmpty(record?.organizers),
                        )}
                      </span>
                    </div>
                  </div>
                );
              })
            )}
            <div className='events-mobile-pagination'>
              <Pagination {...cardPagination} />
            </div>
          </div>
        ) : (
          <Table
            bordered
            className={`admin-table events-admin-table${
              isNarrow ? ' events-admin-table-narrow' : ''
            }`}
            columns={tableColumns}
            dataSource={allEventsData}
            rowKey={'id'}
            scroll={{x: isNarrow ? narrowScrollX : 1300}}
            sticky={!isNarrow}
            onChange={debouncedTableChange}
            pagination={tablePagination}
          />
        )}
      </div>
    </div>
  );
};

export default EventsComponent;
